<div class="modal" [class.modal-open]="open">
  <div class="modal-box paper-modal max-w-3xl">
    <h3 class="h2 mb-3 flex items-center gap-2"><span class="text-primary" aria-hidden="true">🏆</span> Highscores</h3>
    <div class="overflow-x-auto max-h-[70vh]">
      <table class="table table-sm hs-table">
        <thead>
          <tr>
            <th>Platz</th>
            <th>Spieler</th>
            <th class="text-right">Punkte</th>
            <th class="text-right">Datum</th>
          </tr>
        </thead>
        <tbody>
          @for (h of highscores; track h; let i = $index) {
            <tr [class.hs-gold]="i===0" [class.hs-silver]="i===1" [class.hs-bronze]="i===2">
              <td class="whitespace-nowrap">
                @if (i < 3) {
                  <span class="hs-medal" aria-hidden="true">{{ i+1 }}</span>
                } @else {
                  <span class="opacity-60 hs-rank">{{ i+1 }}</span>
                }
              </td>
              <td [class.font-semibold]="i < 3">{{ h.player_name }}</td>
              <td class="text-right font-extrabold hs-score">{{ h.score }}</td>
              <td class="text-right opacity-70 whitespace-nowrap">{{ h.achieved_at | date:'dd.MM.yyyy HH:mm' }}</td>
            </tr>
            <!-- Spacer after third entry -->
            @if (i===2 && highscores.length > 3) {
              <tr aria-hidden="true">
                <td colspan="4" class="py-1"></td>
              </tr>
            }
          }
          @if (highscores.length===0) {
            <tr>
              <td colspan="4" class="opacity-70">Keine Einträge.</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="modal-action">
      <button class="btn btn-primary" (click)="close()">Schließen</button>
    </div>
  </div>
  <div class="modal-backdrop" (click)="close()"></div>
</div>
